export enum AudienceRuleAct {
    IncludeAnd = 0,
    IncludeOr = 1,
    Exclude = 2,
}

export enum AudienceRuleDateType {
    Fixed = 1,
    Relative = 2,
}

export enum AudienceRuleDateReference {
    Event = 1,
    Source = 2,
}
